<script lang="ts">
import Vue from 'vue'
import {Component, Prop, Watch} from 'vue-property-decorator'

@Component({})
export default class SpaceSubnav extends Vue {
  @Prop()
  spaceId: string

  @Prop()
  spaceData: any

  @Prop()
  showCancelOption: boolean

  // list of [name, selector]
  sections = [
    ['Overview', '#main'],
    ['Issues', '#issues'],
    ['Devices', '#devices'],
    ['Emergencies', '#emergencies'],
    ['Caregivers', '#caregivers'],
    ['Recent Events', '#recent-events'],
    ['Sensors', '#sensors'],
  ]

  sectionVisible = {}

  get cancelSpaceUrl() {
    return `/space/${this.spaceId}/cancel`
  }

  get cancelBtnTooltip() {
    if (this.spaceData.plan_status == 'CANCELLED') {
      return 'This space is already cancelled'
    } else if (!this.spaceData.can_cancel) {
      return 'Please wait 5 minutes after setting up a new device to attempt to cancel the space'
    }
  }

  async mounted() {
    this.sections.map(([name, selector]) => {
      Vue.set(this.sectionVisible, name, Boolean($(selector).length))
    })
  }
}
</script>
|
<template>
  <div class="nav-wrap sticky-top row py-3 card rounded-0">
    <div class="col">
      <scrollactive class="nav" active-class="active" :offset="150" :scroll-offset="150">
        <a
          v-for="[name, selector] in sections"
          v-if="sectionVisible[name]"
          :href="selector"
          class="nav-link scrollactive-item">
          {{ name }}
        </a>
        <b-nav-item-dropdown v-if="showCancelOption" class="ml-auto" right>
          <template #button-content>Admin</template>
          <b-dropdown-item
            variant="danger"
            :to="cancelSpaceUrl"
            :disabled="!spaceData.can_cancel"
            v-b-tooltip.hover="cancelBtnTooltip">
            Cancel Space
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </scrollactive>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/css/_variables.scss';
@import 'bootstrap/scss/mixins/breakpoints';

.nav-wrap {
  .active {
    font-weight: bold;
    color: $body-color;
  }

  @include media-breakpoint-up('md') {
    position: sticky;
    top: $dashboard-navbar-height;
    z-index: $zindex-dropdown;
  }
}
</style>
